import React from 'react';
import { connect } from 'react-redux';
import { VictoryChart, VictoryBar, VictoryAxis, VictoryGroup } from 'victory';
import { getTenantState } from '../../../store/selectors';
import { education } from '../../../copy/onboardingCopy.json';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import EducationIconWithLabel from './EducationIconWithLabel';

function HighestLevelOfEducationChart(props) {
  return (
    <div className="highest-level-of-education-chart">
      <VictoryChart domainPadding={{ x: 50 }} width={1300}>
        <VictoryGroup
          colorScale={reportingCopy.highestLevelOfEducation.colorScale}
        >
          {Object.entries(props.data).map(([educationLevel, count]) => {
            return (
              <VictoryBar
                barWidth={40}
                data={[{ x: educationLevel, y: count }]}
                labels={({ datum }) => `${datum.y}`}
                style={{
                  labels: { fontWeight: 'bold', fontFamily: 'Roboto' },
                }}
                key={educationLevel}
              />
            );
          })}
        </VictoryGroup>
        <VictoryAxis
          style={{
            tickLabels: { fill: 'transparent' },
          }}
        />
      </VictoryChart>
      <div className="highest-level-of-education-chart__labels">
        {reportingCopy.highestLevelOfEducation.labels.map((label) => {
          return (
            <EducationIconWithLabel
              education={education}
              educationText={label}
              tenant={props.tenant}
              height="60px"
              width="60px"
              key={label}
            />
          );
        })}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps)(HighestLevelOfEducationChart);
